export default "__VITE_ASSET__CwKwPQGH__"